// Application constants

export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_URL || 'https://localhost:3213',
  TIMEOUT: 30000, // 30 seconds
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000, // 1 second
} as const;

export const QUERY_KEYS = {
  // User queries
  USER_GROUPS: 'user-groups',
  USER_PROFILE: 'user-profile',

  // Group queries
  GROUPS: 'groups',
  GROUP_USERS: 'group-users',
  GROUP_CATEGORIES: 'group-categories',
  GROUP_EXPENSES: 'group-expenses',
  GROUP_BALANCES: 'group-balances',
  FUNDING_POOLS: 'funding-pools',

  // Category queries
  CATEGORIES: 'categories',
  CATEGORY_SUMMARY: 'category-summary',
  CATEGORY_SPLITS: 'category-splits',
  CATEGORY_BALANCES: 'category-balances',

  // Expense queries
  EXPENSES: 'expenses',
  EXPENSE_DETAILS: 'expense-details',

  // Transaction queries (expenses + settlements)
  TRANSACTIONS: 'transactions',

  // Reactive queries
  REACTIVE_EXPENSES: 'reactive-expenses',
} as const;

export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  REFRESH_TOKEN: 'refresh_token',
  USER_DATA: 'user_data',
  THEME: 'theme',
  PREFERENCES: 'preferences',
} as const;

export const ROUTES = {
  HOME: '/',
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
  },
  GROUPS: {
    LIST: '/groups',
    DETAIL: '/groups/:groupId',
    EXPENSES: '/groups/:groupId',
    CATEGORIES: '/groups/:groupId/categories',
    SETTINGS: '/groups/:groupId/settings',
    MEMBERS: '/groups/:groupId/members',
  },
} as const;

export const CURRENCY_CODES = ['EUR', 'USD', 'SEK', 'NOK', 'DKK', 'GBP'] as const;

export const DEFAULT_CURRENCY = 'EUR';

export const PAGINATION = {
  DEFAULT_LIMIT: 20,
  MAX_LIMIT: 100,
} as const;

export const ANIMATIONS = {
  FAST: 150,
  NORMAL: 300,
  SLOW: 500,
} as const;

export const BREAKPOINTS = {
  xs: 475,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1400,
  '3xl': 1920,
} as const;

export const KEYBOARD_SHORTCUTS = {
  SEARCH: 'k',
  NEW_EXPENSE: 'n',
  ESCAPE: 'Escape',
  ENTER: 'Enter',
} as const;

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_SERVER_ERROR: 500,
} as const;
